<template>
    <div ref="popup" class="popup" :id="id">
        <div class="popup-background" @click="closePopup()">&nbsp;</div>
        <div class="popup-content" :style="{ maxWidth: maxWidth }">
            <button class="close" @click="closePopup()"></button>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import EventBus from "../event-bus";

export default {
    name: "PopUp",
    props: {
        id: {
            type: String,
            default: "",
        },
        maxWidth: {
            type: String,
            default: "700px",
        },
    },
    mounted() {
        EventBus.on("openPopup", this.handleOpenPopup);
    },
    beforeUnmount() {
        EventBus.off("openPopup", this.handleOpenPopup);
    },
    methods: {
        handleOpenPopup(id) {
            if (id === this.id) {
                this.openPopup();
            }
        },
        openPopup() {
            const popup = this.$refs.popup;
            popup.classList.add("open");
            setTimeout(() => {
                popup.style.opacity = 1;
            }, 100);
        },
        closePopup() {
            const popup = this.$refs.popup;
            popup.style.opacity = 0;
            setTimeout(() => {
                popup.classList.remove("open");
            }, 300);
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.vars.scss" as *;
.popup {
    display: none;
    z-index: 100;
    opacity: 0;
    transition: opacity 0.3s;

    &.open {
        display: flex;
    }

    .popup-background {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 101;
    }

    .popup-content {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        padding: 46px 22px 24px;
        border-radius: 34px;
        background-color: $color-white;
        z-index: 102;

        @media (max-width: $breakpoint-tablet) {
            left: 16px;
            right: 16px;
            transform: translate(0, -50%);
            width: unset;
            max-width: unset !important;
        }

        @media (max-width: $breakpoint-mobile) {
            padding: 40px 8px 16px;
            border-radius: 20px;
        }

        .close {
            position: absolute;
            top: 28px;
            right: 28px;
            width: 24px;
            height: 24px;
            border: none;
            background-color: transparent;
            background-image: url("~@/assets/customizer_icon_close.svg");
            background-size: 11px;
            background-repeat: no-repeat;
            background-position: center center;
            cursor: pointer;

            @media (max-width: $breakpoint-mobile) {
                top: 8px;
                right: 8px;
            }
        }
    }
}
</style>
